module.exports = __webpack_public_path__ + "img/flor_transparente.ea182b40.png";